import type { IUserProfile } from "./user";

export interface ISigninData {
  email: string;
  password: string;
}

export interface ISigninResponse {
  user: IUserProfile;
  accessToken: string;
  refreshToken: string;
}

export interface ISignupData {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
}

export interface ISignupResponse {
  message: string;
}

export interface IForgotPasswordData {
  email: string;
}

export interface IResetPasswordData {
  token: string;
  password: string;
}

export interface IInviteAcceptDetails {
  email: string;
  organizationName: string;
  requiresSso: boolean;
}

export interface IAcceptInviteData {
  token: string;
  password: string;
  firstName?: string;
  lastName?: string;
}

export interface ISamlLoginParams {
  email: string;
  // NOTE: External-client identifier ("extension" / "mobile"). Echoed
  // through the SAML RelayState so the callback handler knows whether
  // to redirect tokens to `callbackUrl` instead of the web magic-link.
  // Optional — web clients omit it.
  source?: string;
  callbackUrl?: string;
}

export interface ISamlConfig {
  organizationUuid: string;
  organizationName: string;
  samlUrl: string;
}

export interface IAuthMessageResponse {
  message: string;
}

export interface IAuthRedirectResponse {
  url: string;
}

export interface IRefreshTokenResponse {
  accessToken: string;
  // NOTE: NSAI-6847 — the session's refresh credential, returned with every
  // refresh. It is the same one, not a rotated replacement (the session's own
  // uuid). Only the clients that keep it themselves (mobile, the extension)
  // store it; the web's stays in its httpOnly cookie.
  refreshToken?: string;
}

export interface IRegistrationStatusResponse {
  registrationEnabled: boolean;
  googleAuthEnabled: boolean;
  githubAuthEnabled: boolean;
  yandexAuthEnabled: boolean;
  vkAuthEnabled: boolean;
  telegramAuthEnabled: boolean;
  externalApiEnabled: boolean;
}

export interface ISingleOrganizationSaml {
  samlUrl: string;
}

// NOTE: Optional query params accepted by GET /auth/saml/organization.
// External clients (browser extension, mobile) pass these so the SAML
// callback can redirect tokens to `callbackUrl` instead of the web
// magic-link. Web callers omit them.
export interface IGetSingleOrganizationSamlParams {
  source?: string;
  callbackUrl?: string;
}

export enum ESocialAuthProvider {
  GITHUB = "github",
  GOOGLE = "google",
  YANDEX = "yandex",
  VK = "vk",
  TELEGRAM = "telegram",
}
